// project imports
import applications from './applications';
import contractors from './contractors';
import dashboard from './dashboard';

// types
import { NavItemType } from 'types/menu';
import ppf from './ppf';
import permitandinspection from './permitandinspection';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
  items: [dashboard, ppf, contractors, permitandinspection, applications]
};

export default menuItems;
